const Mock = require('mockjs')
Mock.mock('http://localhost:5000/shopList', 'get', function (options) {
    console.log(options)

    return {
        data: [
            {
                classification: '单选题',
                ask: '漏电保护器的使用是防止(   )。',
                A: '检验报告书',
                B: '检验合格标志',
                C: '两者都不是',
                // D: '这是歌德巴赫猜想的基础命题'
            },
            {
                classification: '单选题',
                ask: '使用手持电动工具时，下列注意事项哪个正确?(   )',
                A: '使用万能插座',
                B: '使用漏电保护器 ',
                C: '身体或衣服潮湿',
                // D: '这是歌德巴赫猜想的基础命题'
            },
            {
                classification: '单选题',
                ask: '静电电压最高可达(    )，可现场放电，产生静电火花，引起火灾。',
                A: '50伏',
                B: '数万伏',
                C: '220伏',
                // D: '这是歌德巴赫猜想的基础命题'
            },
            {
                classification: '单选题',
                ask: '装用漏电保护器，是属于哪种安全技术措施?(    )。',
                A: '基本保安措施',
                B: '辅助保安措施',
                C: '绝对保安措施',
                // D: '这是歌德巴赫猜想的基础命题'
            },
            {
                classification: '单选题',
                ask: '工人在从事电工作业时，如见到以下标志，则表示(    )。',
                A: '注意安全',
                B: '当心电缆',
                C: '当心电机伤人',
                // D: '这是歌德巴赫猜想的基础命题'
            }
        ],

        meta: { status: 200, message: '获取数据成功！' }

    }
})